import styled from 'styled-components';
import { Input } from 'ui-components/src/components/atoms';

export const StyledInput = styled(Input)`
  margin-top: 1rem;
`;
